import { isServer } from "@tanstack/react-query"; // or write your own isServer check
import { createStore } from "jotai";

let browserJotaiStore: ReturnType<typeof createStore> | undefined;

export const getJotaiStore = () => {
  if (isServer) {
    // Always create a new store on the server
    return createStore();
  }

  // On the client, create the store once and reuse it
  if (!browserJotaiStore) browserJotaiStore = createStore();
  return browserJotaiStore;
};
